/**
 * SemanticDegradedNotice — the one line every search surface shows when the semantic leg
 * of a hybrid search is down (`semantic_available: false`).
 *
 * S4 made the degraded signal visible in the global header bar. The Policies and Ablage
 * pages run the same hybrid through their own "Semantisch" toggle and were still silent
 * about it, so a broker there reads keyword hits as if they were the full answer. The
 * wording lives here rather than in each screen: three copies of a sentence drift, and
 * this one is a promise about what the results are.
 *
 * `variant` only sets the frame - the global dialog sits under a header border, the list
 * screens sit in the pinned toolbar block. The sentence is identical in both.
 *
 * [Source: apps/web/src/features/search/GlobalSearchDialog.tsx] (the original S4 line)
 */
import { AlertCircle } from 'lucide-react';

/** The exact sentence. Exported so a test asserts on it instead of retyping it. */
export const SEMANTIC_DEGRADED_TEXT =
  'Semantische Suche momentan nicht verfügbar. Die Ergebnisse stammen aus der Volltextsuche.';

interface SemanticDegradedNoticeProps {
  /** 'dialog' = the global search panel, 'list' = a ListView toolbar block. */
  variant?: 'dialog' | 'list';
}

export function SemanticDegradedNotice({ variant = 'list' }: SemanticDegradedNoticeProps) {
  const frame =
    variant === 'dialog' ? 'border-b px-2 py-2' : 'mb-2 rounded-md bg-muted/60 px-2.5 py-1.5';
  return (
    <p role="status" className={`flex items-center gap-2 text-xs text-muted-foreground ${frame}`}>
      <AlertCircle className="size-3.5 shrink-0" aria-hidden />
      {SEMANTIC_DEGRADED_TEXT}
    </p>
  );
}
